/**
 * 4Talks - Individual talks page
 * Video start controls
 * Slide text/watct now button down out of the way of the video
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

const talkVideoControls = () => {
    const watchNowButton = document.getElementById('watchNow');
    if (!watchNowButton) return;

    const headerInfo = document.querySelector('.singleTalk__header');
    const pageContent = document.querySelector('.singleTalk__content');
    const videoEl = document.querySelector('.singleTalk__splash--video iframe');

    const calcPositioning = () => {
        headerInfo.style.transform = 'translateY(40px)';
        pageContent.style.marginTop = `${headerInfo.clientHeight + 40}px`;
        headerInfo.style.marginBottom = `-${headerInfo.clientHeight}px`;
    };

    watchNowButton.addEventListener('click', () => {
        watchNowButton.blur();

        if (!watchNowButton.classList.contains('register')) {
            document.body.classList.add('videoPlaying');
            calcPositioning();
            videoEl.setAttribute('tabindex', '0');
        }
    });

    window.addEventListener('resize', () => {
        if (document.body.classList.contains('videoPlaying')) {
            calcPositioning();
        } else {
            headerInfo.style.marginBottom = `-${headerInfo.clientHeight}px`;
        }
    });

    window.addEventListener('load', () => {
        headerInfo.style.marginBottom = `-${headerInfo.clientHeight}px`;
        videoEl.setAttribute('tabindex', '-1');
    });
};

export default talkVideoControls;
